module.exports = __webpack_public_path__ + "img/1560988724.660ee3d9.jpg";